import type { ICampaignMetricKey } from '~/modules/campaign-analytics/types';
import type { IBasePageAnalyticMetric } from '~/modules/page-analytic/types';
import type { EMPTY_METRIC_DATA } from './../../campaign/constants/metric';
import type { IAnalyticMetric } from '~/types/metric';

export enum IMetricFormatter {
  PERCENTAGE_STRING = 'PERCENTAGE_STRING',
  CURRENCY = 'CURRENCY',
  DURATION = 'DURATION',
  DURATION_MS = 'DURATION_MS',
  MILLISECONDS = 'MILLISECONDS',
  NORMAL = 'NORMAL',
  NUMBER_COMMAS = 'NUMBER_COMMAS',
  NUMBER_COMMAS_LEAN = 'NUMBER_COMMAS_LEAN',
}

export interface IDetectMetricResult<K = number | undefined | typeof EMPTY_METRIC_DATA> {
  formatter: IMetricFormatter;
  value: K;
}

export interface IAnalyticMetricShowing {
  metricKey: ICampaignMetricKey;
  position: number;
}

type IMetric = IBasePageAnalyticMetric | IAnalyticMetric;
export type IFunctionGetMetric<T = IMetric> = (props: { metric?: T }) => IDetectMetricResult;
export type IFunctionGetMetricWithKeys<
  K extends string,
  R = IDetectMetricResult<number | undefined>,
> = (props: { metric?: Record<K, number | undefined> }) => R;
